import React, { useContext } from 'react'
import { AppConfigContext } from '../../context/AppConfig'

function VariantWrapper({ hide, show, children }) {
  const { variant } = useContext(AppConfigContext)

  if (hide && typeof hide === 'string') hide = [hide]
  if (show && typeof show === 'string') show = [show]

  return (
    <>
      {!show && <>{hide && hide.find(e=>e === variant) ? null : children}</>}
      {!hide && <>{show && show.find(e=>e === variant) ? children : null}</>}
    </>
  )
}

export default VariantWrapper
